'use client';

import React, { forwardRef } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import styled from '@emotion/styled';
import { color } from '@/theme/tokens';

const StyledIconButton = styled(IconButton)`
    &:hover {
        background-color: ${color.black[5]};
    }
    &:active {
        background-color: ${color.black[10]};
    }
    &.Mui-focusVisible {
        outline: 2px solid ${color.gray[80]};
        outline-offset: 2px;
    }
`;

const IconButtonGray = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
    return <StyledIconButton disableRipple ref={ref} {...props} />;
});

IconButtonGray.displayName = 'IconButtonGray';

export default IconButtonGray;

